"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Constant = require("../../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &&:first-child {\n    margin-top: 16px;\n  }\n\n  @media (min-width: ", "px) {\n    &&:first-child {\n      margin-top: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_Button.default)(_templateObject(), _Constant.Width.SM);

exports.default = _default;